import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withFirebase, isEmpty, isLoaded } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import PropTypes from 'prop-types';
import {
  openCompanySignupModal,
  openInfluencerSignupModal
} from '../../store/actions/signupModalActions';
import { openSignupModal } from '../../store/actions/signupModalActions';
import MetaTags from 'react-meta-tags';
import 'bootstrap/dist/css/bootstrap.css';
import './Home.css';
import Fab from '@material-ui/core/Fab';
import { Grid } from '@material-ui/core';
import SmsIcon from '@material-ui/icons/Sms';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import Fade from 'react-reveal/Fade';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faYoutube,
  faTwitch
} from '@fortawesome/free-brands-svg-icons';

class Landing extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <React.Fragment>
        <div className="for-companies-container">
          <MetaTags>
            <title>Hype Up Your Reach for Free with HypePilot</title>
            <meta
                name="description"
                content="Connect with and source the hottest influencers on leading platforms like YouTube. Our platform allows direct messaging with influencers and provides the info that counts via analytics which provide details like follower counts and more."
            />
            <meta
                name="keywords"
                content="Influencer Marketing, Influencer Platform, Influencer Marketplace,YouTube Influencers, Instagram Influencers, Twitch Influencers,YouTube,Instagram,Twitch,Influencer,Influencers,Marketplace,Platform"
            />
          </MetaTags>
          <div className="nav-bar-holder">
            <nav className="navbar navbar-expand-sm navbar-light" />
          </div>
          <div className="text-header-container">
            <div className="container">
              <div className="header-holder">
                <h1 className="page-text-heading-brand" style={{width: '80%'}}>Hype Up Your Reach for Free with HypePilot</h1>
              </div>
              <p className="padded-top-paragraph">
                HypePilot is a gaming marketing platform that does it all –
                from connecting gamers to companies to letting you run and manage
                killer gaming product campaigns – from one single, streamlined space.
                Stay on top of the game with an open gaming marketplace built for you and you alone.
              </p>
            </div>
          </div>
          <img className="side-page-img" src="/images/brand-page-pic.png" />
          <div className="container">
          <div className="header-holder">
            <h1 className="page-text-heading-brand" style={{width: '80%'}}> Don’t Pause Progress</h1>
          </div>
          <p className="padded-top-paragraph">
            Here are some of the awesome features that are shooting HypePilot into a league of our own.
            With our gaming marketing platform, you can:
          </p>
          </div>
          <div
              id="features"
              className="influencer-wrapper container primary-font-color"
          >
            <div className="row">
              <div className="col-sm-6">
                <img
                    className="influencer-icon-7"
                    src="/images/format-list-checks.png"
                />
                <h3 className="influencer-heading">Track your deals</h3>
                <p className="influencer-para">
                  Our deal management interface helps you
                  stay on top of the game by giving you
                  unlimited insight into your or a partner’s previous deals.
                  You can revise or request revisions.
                  You can send and receive updates.
                  You can even use our built-in messaging system to chat.
                </p>
              </div>
              <div className="col-sm-6">
                <img className="influencer-icon-2" src="/images/chart-line.png" />
                <h3 className="influencer-heading">Find People Who’ve Got the Right Stuff</h3>
                <p className="influencer-para">
                  Whether you’re an influencer or a brand,
                  you need to be sure that you’re working with
                  people who are as passionate and professional as you are.
                  Thanks to our search and suggest features,
                  you can find the perfect connections to grow your gaming audience.
                  Better yet? You can quickly stalk their social profiles
                  and past deals to get a feel of who you’re working with.
                </p>
              </div>
            </div>
            <div className="row padded-top-row">
              <div className="col-sm-6">
                <img className="influencer-icon-5" src="/images/forum.png" />
                <h3 className="influencer-heading">See What’s Going on Behind the Scenes</h3>
                <p className="influencer-para">
                  When it comes to connecting gamers and companies,
                  we want to give you the real,
                  hard data behind the screen.
                  As a brand, you can find influencer statistics in a
                  second to see how many views and followers any gaming influencer has.
                  What other gaming marketing platform can say the same?
                </p>
              </div>
              <div className="col-sm-6">
                <img className="influencer-icon-5" src="/images/view-list.png" />
                <h3 className="influencer-heading">Let The Trust Go Both Ways</h3>
                <p className="influencer-para">
                  Gaming digital marketing platforms prioritize gaming influencers over companies
                  – and vice versa – too often. We’re evening the playing field by giving you
                  – whether you’re a streamer or a gaming brand
                  – the chance to leave an in-depth review of the quality of service,
                  customer relationships, and overall experience you had with another HypePilot user.
                </p>
              </div>
              <div className="col-sm-6">
                <img className="influencer-icon-5" src="/images/view-list.png" />
                <h3 className="influencer-heading">Manage Your Campaigns and Get Paid</h3>
                <p className="influencer-para">
                  Let’s talk money and how to make sure you get it.
                  While HypePilot is completely free, we make a point of
                  ensuring that both parties get paid for their hard work and commitment.
                  You can also create and manage each of your campaigns
                  for free while requesting revisions and finalizing payouts (in products and in money).
                </p>
              </div>

              <div className="col-sm-6">
                <img className="influencer-icon-5" src="/images/view-list.png" />
                <h3 className="influencer-heading">Laser-Target Your Audience</h3>
                <p className="influencer-para">

                  Our gaming marketing platform does more than grow your follower count
                  – it gives you real, valuable insights into the people who are checking
                  out your content, products, and campaigns. Your HypePilot dashboard
                  gives you a variety of nifty widgets that will help you navigate the
                  analytics and stats of your gaming product campaigns or content.
                </p>
              </div>
            </div>
          </div>
          <div className="nav-bar-holder">
            <nav className="navbar navbar-expand-sm navbar-light" />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Landing.propTypes = {
  authExists: PropTypes.bool,
  router: PropTypes.object
};

export default Landing;



// WEBPACK FOOTER //
// ./src/components/home/Landing.js